module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAAQCAYAAACBSfjBAAAA2ElEQVRYR+3UvQ3CMBAF4HdhACagpkooKOgoAxsgkEhSINgCiQkYgAbSQkXnVIyAwgoMwACIQ3GdHytX5lz7neRPz0fQUyrgJ1lCPz6yR9vXObxWMZH6lQsEUbYB+ATG1+vR6lmBqIA1DfLj7EDM+zpEBWz4gk2ICuiww+oQFdABsLhShWgB/dhMAYwdZ3X2GjF2AIbFTgRhmaezmwUM1uYDQr+zMq0ezu88nQ8s4CgyCzAmreZ0NMQePfJLeNcdKCyAAiqgUEAY1wYqoFBAGNcGKqBQQBj/A2/0SRHedMkqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_ic_arrows.png
// module id = 6+UG
// module chunks = 3